import "./App.css";
import "./styles/commandCenter.css";

import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material";

import routes from "./routes";
import WebTheme from "./Theme/WebTheme";
import { useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import { Suspense } from "react";
import SuspenseLoader from "./components/Loader/SuspenseLoader";

// Created once at module level — never recreated on re-render.
// Previously these were inside App(), which caused createBrowserRouter to run
// on every Redux dispatch, giving RouterProvider a new router instance each
// time and unmounting/remounting the entire route tree (full-page reload feel).
const authRouter  = createBrowserRouter(routes.filter((r) => !r.isGuest));
const guestRouter = createBrowserRouter(routes.filter((r) => r.isGuest || r.isLogged === false));

function App() {
  const { isLoggedIn } = useSelector((state) => state.auth);
  return (
    <>
      <ThemeProvider theme={WebTheme}>
        <Suspense fallback={<SuspenseLoader />}>
          <Toaster
            position="top-right"
            reverseOrder={false}
            toastOptions={{
              style: {
                background: "#ffffff",
                color: "#1e293b",
                padding: 0,
                boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
                borderRadius: "8px",
                maxWidth: "400px",
              },
            }}
          />
          <RouterProvider router={isLoggedIn ? authRouter : guestRouter} />
        </Suspense>
      </ThemeProvider>
    </>
  );
}

export default App;
